import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { GitFork, CheckCircle2 } from 'lucide-react';
import { ICON_PX } from '../../ui';

/**
 * Parallel (AND-split) node — represents concurrent execution tracks.
 * Visually a rounded container with a fork icon.
 */
function ParallelNode({ data, selected }) {
  const { label, status = 'pending' } = data;
  const isSatisfied = status === 'satisfied';
  const isAvailable = status === 'available';

  return (
    <>
      <Handle type="target" position={Position.Top} className="!bg-[var(--slate)] !w-2.5 !h-2.5 !border-2 !border-white !rounded-full" />

      <div
        className={[
          'rounded-xl border-2 border-dashed px-5 py-3 min-w-[180px] text-center transition-all',
          isSatisfied ? 'bg-green-bg border-[var(--green)] shadow-sm' :
          isAvailable ? 'bg-[var(--aqua)]/5 border-[var(--aqua)] shadow-md' :
          'bg-slate-50 border-slate-300 shadow-sm',
          selected ? 'ring-2 ring-aqua ring-offset-2' : '',
        ].join(' ')}
      >
        <div className="flex items-center justify-center gap-1.5 mb-1">
          {isSatisfied ? (
            <CheckCircle2 size={ICON_PX.md} className="text-green-nn" />
          ) : (
            <GitFork size={ICON_PX.md} className={isAvailable ? 'text-[var(--aqua)]' : 'text-slate-400'} />
          )}
          <span className={`text-xs font-semibold uppercase tracking-wide ${
            isSatisfied ? 'text-green-nn' : isAvailable ? 'text-[var(--aqua)]' : 'text-slate-400'
          }`}>
            Parallel
          </span>
        </div>
        <span className={`text-sm font-medium ${isSatisfied ? 'text-green-nn' : 'text-text-dark'}`}>
          {label || 'Run in parallel'}
        </span>
      </div>

      <Handle type="source" position={Position.Bottom} className="!bg-[var(--slate)] !w-2.5 !h-2.5 !border-2 !border-white !rounded-full" />
    </>
  );
}

export default memo(ParallelNode);
